// Слайдер на странице item в блоке Imagine it...
(() => {
  function initImagineItSlider(root = document) {
    const slider = root.querySelector('.painting-slider');

    if (!slider || slider.dataset.imagineSliderInitialized === 'true') {
      return;
    }

    const track = slider.querySelector('.painting-slider__track');
    const slides = track ? [...track.querySelectorAll('.painting-slider__slide')] : [];
    const nextButton = slider.querySelector('.btn-next');

    if (!track || slides.length === 0) {
      return;
    }

    slider.dataset.imagineSliderInitialized = 'true';

    const autoplayDelay = 4000;
    const swipeThreshold = 60;

    let positions = [0];
    let currentPositionIndex = 0;

    let isDragging = false;
    let isInView = false;

    let startX = 0;
    let currentX = 0;
    let dragOffset = 0;

    let autoplayTimer = null;

    function getGap() {
      const styles = window.getComputedStyle(track);

      return (
        parseFloat(styles.columnGap) ||
        parseFloat(styles.gap) ||
        0
      );
    }

    function calculatePositions() {
      const gap = getGap();

      const maxOffset = Math.max(
        0,
        track.scrollWidth - slider.clientWidth
      );

      const newPositions = [0];

      let offset = 0;

      for (let index = 1; index < slides.length; index += 1) {
        offset +=
          slides[index - 1].getBoundingClientRect().width + gap;

        if (offset >= maxOffset) {
          break;
        }

        newPositions.push(offset);
      }

      if (
        maxOffset > 1 &&
        Math.abs(newPositions[newPositions.length - 1] - maxOffset) > 1
      ) {
        newPositions.push(maxOffset);
      }

      positions = newPositions;

      currentPositionIndex = Math.min(
        currentPositionIndex,
        positions.length - 1
      );
    }

    function getCurrentOffset() {
      return positions[currentPositionIndex] || 0;
    }

    function updateSlider(animate = true) {
      track.style.transition = animate
        ? 'transform 500ms ease'
        : 'none';

      track.style.transform =
        `translate3d(-${getCurrentOffset()}px, 0, 0)`;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (
        !isInView ||
        isDragging ||
        positions.length < 2 ||
        document.hidden
      ) {
        return;
      }

      autoplayTimer = setInterval(() => {
        nextSlide();
      }, autoplayDelay);
    }

    function nextSlide() {
      if (positions.length < 2) {
        return;
      }

      currentPositionIndex += 1;

      if (currentPositionIndex >= positions.length) {
        currentPositionIndex = 0;
      }

      updateSlider();
      startAutoplay();
    }

    function previousSlide() {
      if (positions.length < 2) {
        return;
      }

      currentPositionIndex -= 1;

      if (currentPositionIndex < 0) {
        currentPositionIndex = positions.length - 1;
      }

      updateSlider();
      startAutoplay();
    }

    slider.addEventListener('pointerdown', (event) => {
      if (event.target.closest('.btn-next')) {
        return;
      }

      if (event.pointerType === 'mouse' && event.button !== 0) {
        return;
      }

      isDragging = true;

      startX = event.clientX;
      currentX = startX;
      dragOffset = getCurrentOffset();

      stopAutoplay();

      slider.classList.add('is-dragging');
      slider.setPointerCapture(event.pointerId);

      track.style.transition = 'none';
    });

    slider.addEventListener('pointermove', (event) => {
      if (!isDragging) {
        return;
      }

      currentX = event.clientX;

      const distance = currentX - startX;

      track.style.transform =
        `translate3d(${-dragOffset + distance}px, 0, 0)`;
    });

    function finishDragging() {
      if (!isDragging) {
        return;
      }

      isDragging = false;
      slider.classList.remove('is-dragging');

      const distance = currentX - startX;

      if (Math.abs(distance) >= swipeThreshold) {
        if (distance < 0) {
          nextSlide();
        } else {
          previousSlide();
        }
      } else {
        updateSlider();
        startAutoplay();
      }

      startX = 0;
      currentX = 0;
    }

    slider.addEventListener('pointerup', finishDragging);
    slider.addEventListener('pointercancel', finishDragging);

    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        nextSlide();
      });
    }

    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        isInView =
          entry.isIntersecting &&
          entry.intersectionRatio >= 0.35;

        if (isInView) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      },
      {
        threshold: [0, 0.35],
      }
    );

    const resizeObserver = new ResizeObserver(() => {
      calculatePositions();
      updateSlider(false);
    });

    resizeObserver.observe(slider);
    resizeObserver.observe(track);

    slides.forEach((slide) => {
      resizeObserver.observe(slide);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    window.addEventListener('load', () => {
      calculatePositions();
      updateSlider(false);
    });

    calculatePositions();
    updateSlider(false);

    intersectionObserver.observe(slider);
  }

  function init(root = document) {
    initImagineItSlider(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => init(event.target)
  );
})();